import { borders, colors } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import { textStyles } from "~/styleguide/typography";
import tinyColor from "tinycolor2";

/**
 * Button styling
 *
 * Should be using inside of a FELA extend array.
 */

//TODO: Outline style should probably always have a transparent background?

export const buttons = ({
    layout,
    size = "regular",
    backgroundColor,
    color,
    colorTheme = null,
    outline = false
}) => {
    let outlineColor = null;

    if (colorTheme && !outline) {
        backgroundColor = colorTheme.button;
    }

    if (colorTheme && !color) {
        if (colorTheme.text === "dark") {
            color = colors.blue;
            outlineColor = colors.blue;
        } else {
            color = colors.white;
            outlineColor = colors.white;
        }
    }

    return {
        condition: layout === "button",
        style: {
            display: "inline-block",
            background: backgroundColor,
            borderRadius: borders.radius.pill,
            letterSpacing: "0.2px",
            cursor: "pointer",
            color: color,
            // Clear button element styles
            appearance: "none",
            border: "none",
            outline: false,
            whenActive: {
                background: tinyColor(backgroundColor)
                    .lighten(14.5)
                    .toString()
            },
            ":visited": {
                color: "inherit"
            },
            extend: [
                {
                    condition: !outline,
                    style: {
                        color: "white"
                    }
                },
                {
                    condition: size === "regular",
                    style: {
                        fontWeight: 700,

                        extend: [
                            fluid("paddingV", { max: 8, min: 4 }),
                            fluid("paddingH", { max: 16, min: 10 })
                        ]
                    }
                },
                {
                    condition: size === "large",
                    style: {
                        "> span": textStyles.paragraphLarge,

                        extend: [
                            fluid("paddingV", { max: 16, min: 13 }),
                            fluid("paddingH", { max: 34, min: 20 })
                        ]
                    }
                },
                {
                    condition: size === "large" && outline,
                    style: {
                        borderWidth: "2px",
                        borderStyle: "solid",
                        borderColor: outlineColor,
                        whenActive: {
                            backgroundColor:
                                tinyColor(
                                    backgroundColor === "#FFFFFF"
                                        ? "#cccccc"
                                        : backgroundColor
                                )
                                    .lighten(14.5)
                                    .toString() + "!important"
                        },
                        extend: [
                            fluid("paddingV", { max: 14, min: 11 }),
                            fluid("paddingH", { max: 32, min: 19 })
                        ]
                    }
                }
            ]
        }
    };
};

/**
 * Text styles
 */
export const text = ({ layout, color = colors.blue }) => ({
    condition: layout === "text",
    style: {
        color: color,
        fontWeight: 700,
        ":visited": {
            color: color
        },
        whenActive: {
            color: tinyColor(color)
                .lighten(14.5)
                .toString()
        }
    }
});
